import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import SessionTitleRow from "./SessionTitleRow";
import CompletedSessionDetailsCard from "./CompletedSessionDetailsCard";
import ScreenerCard from "./ScreenerCard";
import AboutUserCard from "./AboutUserCard";

// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";



function CompletedSessionPage(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, sessionId } = useParams()

    const [recordings, setRecordings] = useState([]);
    const [streamingUrl, setStreamingUrl] = useState("");
    const [transcript, setTranscript] = useState("");
    const [loadingRecordings, setLoadingRecordings] = useState(true);

    useEffect(() => {
        async function getEventRecordings() {
            console.log("Trying to download recordings")
            const result = await ScheduledEventAPI.one_mission_show_event_recordings({ missionId, sessionId, handleRedirect: navigate });

            if (result.success) {
                setRecordings(result.recordings)
                setStreamingUrl(result.streaming_url)
                setTranscript(result.transcript)
                setLoadingRecordings(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getEventRecordings();
    }, []);


    return (
        <>
            <SubHeader title={"Session"} backText="Back to Completed Sessions" navigateBack={() => navigate("/missions/" + missionId + "/sessions/")} />
            <MissionPageContainer>
                <SessionTitleRow session={props.session} timezone={props.timezone} />
                <CompletedSessionDetailsCard session={props.session} timezone={props.timezone} recordings={recordings} loadingRecordings={loadingRecordings} streamingUrl={streamingUrl} transcript={transcript} />
                {props.hasScreener ? <ScreenerCard mission_user_list_id={props.session.mission_user_list_id} /> : null}
                <AboutUserCard mission_user_list_id={props.session.mission_user_list_id} />
            </MissionPageContainer>
        </>

    )

}

export default CompletedSessionPage;